import React, { Component } from 'react';
import Radium from 'radium';
import Bubble from './Bubble';


class BubblesHeader extends Component {

	getSelectedBubble() {
		if (this.props.allOn) {
			return null;
		}

		return this.props.selectedBubble;
	}

	renderAdd() {
		if (!this.props.allOn) {
			return null;
		}

		return (
			<Bubble
				style={this.props.style}
				allOn={false}
				addIcon={true}
				onSelect={() => this.props.onShowAddBubble()}
			/>
		);
	}

	render() {
		return (
			<div style={this.localStyles().container}>
				{this.props.bubbles.map((bubble) => {
					return (
						<Bubble
							key={bubble.id}
							bubble={bubble}
							allTasks={this.props.allTasks}
							style={this.props.style}
							allOn={this.props.allOn}
							selectedBubble={this.getSelectedBubble()}
							onSelect={() => this.props.onSelectBubble(bubble)}
						/>
					)
				})}

				<Bubble
					style={this.props.style}
					allTasks={this.props.allTasks}
					selectedBubble={this.getSelectedBubble()}
					allOn={this.props.allOn}
					onSelect={() => this.props.onSelectBubble(null)}
				/>

				{this.renderAdd()}
			</div>
		);
	}

	localStyles() {
		return {
			container: {
				display: "flex",
				flexDirection: "row"
			}
		};
	}
}

export default Radium(BubblesHeader);


// WEBPACK FOOTER //
// ./src/components/BubblesHeader.js